<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="产品资料"
      :showFooter="false"
      width="960px"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <!-- // 业务 -->
      <el-button 
        type="primary" 
        size="small" 
        style="margin-bottom: 10px;" 
        @click="upload"
        v-permission="`ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$uploadProInformation`"
      >上传</el-button>

      <el-table
        :data="tableData"
        style="width: 100%;margin-bottom: 20px;"
        row-key="id"
        border
        v-if="show"
      >
        <el-table-column
          prop="fileName"
          label="文件">
        </el-table-column>
        <el-table-column
          prop="fileType"
          label="类型"
          width="80px">
        </el-table-column>
        <el-table-column
          prop="updateInstructions"
          label="更新说明">
        </el-table-column>
        <el-table-column
          prop="uploadTime"
          label="更新时间"
          width="160px"
          :formatter="dateFormatter">
        </el-table-column>
        <el-table-column
          prop="operator"
          label="操作人"
          width="80px">
        </el-table-column>
        <el-table-column
          label="操作" width="100px">
          <template slot-scope="scope">
            <el-button type="text" @click="showPreview(scope.row)" v-if="scope.row.fileType==='说辞表'">预览</el-button>
            <el-button type="text" @click="down(scope.row)" v-if="scope.row.fileType==='说辞表'">下载</el-button>
            <el-button type="text" @click="open(scope.row)" v-if="scope.row.fileType!='说辞表'">打开</el-button>
          </template><!--@click="downLoadRequest(scope.row.spuId,scope.row.fileId, scope.row.fileName)"-->
        </el-table-column>
      </el-table>
      <pre-view :visible.sync="preViewvisible" v-if="preViewvisible" :spuId="viewData.spuId"
                :fileId="viewData.fileId"></pre-view>
    </q-dialog>
  </div>
</template>

<script>
  import moment from 'moment'
  import preView from './preview'
  import pagePathMixin from '@/utils/page-path-mixin'

  export default {
    model: {
      prop: 'visible',
      event: 'input'
    },
    components: {
      preView
    },
    mixins: [pagePathMixin],
    props: ['visible', 'spuId', 'spuInfo'],
    data() {
      return {
        // 业务
        tableData: [],
        preViewvisible: false,
        viewData: {},
        show:false
      }
    },
    computed: {
      dialogVisible: {
        get() {
          return this.visible
        },
        set(val) {
          this.$emit('update:visible', val)
        },
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      down(row) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(async _=>{
          if (row.fileType === '说辞表') {
            await this.downLoadRequest(row.spuId, row.fileId, row.fileName)
            loading.close();
          } else {
            this.downLoad(row.fileRoute, row.fileName)
            loading.close();
          }
        },300)
      },
      open(row) {
        console.log(row);
        this.$q.newProduct.informationPreview({
          params: {
            fileId: row.fileId
          },
          options: {
            responseType: 'blob'
          }
        })
        .then(res=>{
          if(res.code == 200) {
            let pdfUrl = res.data.filePath;
            this.openSubPage({path:'/previewPdf',query:{pdfUrl}})
            // window.open(res.data.filePath)
          }
        })
      },
      updateVal() {
        this.dialogVisible = false;
        if (this.isNeedRefresh) {
          this.$emit('success');
        }
        this.$emit('close');
      },
      confirm() {
        this.updateVal();
      },
      // 业务
      init() {
        this.show = false
        let data = {
          spuId: this.spuId,
          type: '5'
        }
        this.$q.newProduct.queryProductDataCopywriting({params: data})
          .then(res => {
            this.tableData = res.data;
            console.log(res.data);
          }).finally(()=>{
            this.show = true
        })
      },
      downLoad(path, name) {
        let url = path;
        let fileName = name;
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "blob";
        xhr.onload = function () {
          if (xhr.status === 200) {
            if (window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(xhr.response, fileName);
            } else {
              var link = document.createElement("a");
              var body = document.querySelector("body");

              link.href = window.URL.createObjectURL(xhr.response);
              link.download = fileName;

              // fix Firefox
              link.style.display = "none";
              body.appendChild(link);

              link.click();
              body.removeChild(link);
              window.URL.revokeObjectURL(link.href);
            }
          }
        };
        xhr.send();
      },
      /*    downLoad(row) {
            let url = row.fileRoute;
            let fileName = row.fileName;
            var xhr = new XMLHttpRequest();
            xhr.open("GET",url, true);
            xhr.responseType = "blob";
            xhr.onload = function() {
              if (xhr.status === 200) {
                if (window.navigator.msSaveOrOpenBlob) {
                  navigator.msSaveBlob(xhr.response, fileName);
                } else {
                  var link = document.createElement("a");
                  var body = document.querySelector("body");

                  link.href = window.URL.createObjectURL(xhr.response);
                  link.download = fileName;

                  // fix Firefox
                  link.style.display = "none";
                  body.appendChild(link);

                  link.click();
                  body.removeChild(link);
                  window.URL.revokeObjectURL(link.href);
                }
              }
            };
            xhr.send();
          },*/
      downLoadRequest(spuId, fileId, fileName) {
        return this.$q.newProduct.downLoadExcuseExcel({
          data: {
            fileId: fileId,
            spuId: spuId
          },
          options: {
            responseType: 'blob'
          }
        })
          .then(res => {
            console.log(res)
            this.blobDownload(res, fileName)
          }).catch(e => {
          this.$message.error(e.message)
        })
      },
      blobDownload(res, fileName) {
        let objectUrl = window.URL.createObjectURL(res);
        let a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileName;
        a.click()
        a.remove();
      },
      dateFormatter(row, column, cellValue, index) {
        return moment(row.uploadTime).format('YYYY-MM-DD HH:mm:ss')
      },
      upload() {
        this.$router.push('/newProduct/productInfomationUpload')
      },
      showPreview(data) {
        this.viewData = data
        this.preViewvisible = true;
      }
    }
  }
</script>

<style lang="stylus" scoped>
  >>> .el-upload-list__item:first-child
    margin-top 0px

  >>> .el-upload-list__item
    margin-top 0px

  >>> .el-upload-list__item-name
    margin-right 0px
</style>
